import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import Button from '@mui/material/Button';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { FormControl } from '@mui/material';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import DirectionsIcon from '@mui/icons-material/Directions';

import Alert from '@mui/material/Alert';
import axios from '../../../../api/axios';

const URL = "./payment";

function AddPayment() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [id, setId] = useState('');
  const { data, action } = state || "";
  const [retirementPerson, setRetirementPerson] = useState('');
  const [memberid, setMemberid] = useState('');
  const [searchKey, setSearchKey] = useState('');
  const [membername, setMembername] = useState('');
  const [age, setAge] = useState('');
  const [amount, setAmount] = useState('');
  const [type, setType] = useState('Retirement');
  const [paymentType, setpaymentType] = useState('Cash');
  const [searchType, setSearchType] = useState('none');
  const [adharCardNo, setAdharCardNo] = useState('');
  const [phoneNo, setPhoneNo] = useState('');
  const [remarks, setRemarks] = useState('Retired Person Name:');
  const [retirementList, setRetirementList] = useState([]);
  const [alertOpen, setAlertOpen] = useState(false);
  const [severity, setSeverity] = useState('');
  const [message, setMessage] = useState('');

  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [userDefault, setUserDefault] = useState('1');

  const handleClick = () => {
    setAlertOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setAlertOpen(false);
  };

  const handleSave = async (e) => {
    e.preventDefault();

    const data = {
      retirementPerson,
      memberid,
      membername,
      age,
      amount,
      type,
      remarks,
      adharCardNo,
      phoneNo,
      paymentType
    };

    // Check for empty values
    for (const [key, value] of Object.entries(data)) {
      if (!value) {
        alert(`Please fill out the ${key} field.`);
        return; // Exit the function if any required field is empty
      }
    }

    // Specific validations for age, amount, adharCardNo, and phoneNo
    if (isNaN(age) || age <= 0) {
      alert("Please enter a valid age.");
      return;
    }

    if (isNaN(amount) || amount <= 0) {
      alert("Please enter a valid amount.");
      return;
    }

    if (!/^\d{12}$/.test(adharCardNo)) {
      alert("Please enter a valid 12-digit Aadhar Card number.");
      return;
    }

    if (!/^\d{10}$/.test(phoneNo)) {
      alert("Please enter a valid 10-digit phone number.");
      return;
    }

    if (action == "update") {

      try {
        const response = await axios.post(`${URL}/${id}/update`, data);
        handleSuccess(response.data);
      } catch (err) {
        handleException(err?.response?.data);
      }
    } else {

      try {
        const response = await axios.post(`${URL}/add`, data);
        handleSuccess(response.data);
      } catch (err) {
        handleException(err?.response?.data);
      }
    }

  };

  const handleSuccess = (data) => {
    setSeverity("success");
    setMessage(data.message);
    setAlertOpen(true);
    setTimeout(() => {
      navigate("/ViewPayment");
    }, 2000); // Matches autoHideDuration
  };

  const handleException = (data) => {
    setSeverity("error");
    setMessage(data.message || 'An error occurred');
    setAlertOpen(true);
    setAge('');
    setMembername('');
  };

  useEffect(() => {

    if (action == "update") {
      // console.log("payment data "+data.id);
      setId(data.id);
      setAge(data.age);
      setMemberid(data.memberid);
      setMembername(data.membername);
      setPhoneNo(data.phoneNo);
      setAdharCardNo(data.adharCardNo);
      setAmount(data.amount);
      setRemarks(data.remarks);
      setType(data.type);
      setRetirementPerson(data.retirementPerson);
      setpaymentType(data.paymentType);
    }

    if (userDefault == 1) {
      loadRetirementCount();
    }

    setToDate("2024-12-31");
    setFromDate("2024-01-01");

  }, [data, action]);


  const loadRetirementCount = async () => {
    try {
      const response = await axios.get("/employeeInformation/getRetirementCount/");
      setRetirementList(response.data.message || []);
    } catch (err) {
      if (!err?.response) {
        console.log("No server response");
      } else {
        console.log(err?.response.data);
      }
    }
  };

  const fetchMemberData = async () => {
    try {

      const response = await axios.post("./employeeInformation/getsByMemberId", { memberID: searchKey });
      // setDataLisesponse.data.data || []);t(r
      // console.log("data from server" + response.data.message || []);
      if (response.data.success == 1) {
        setAge(response.data.message[0].age);
        setMemberid(response.data.message[0].memberID);
        setMembername(response.data.message[0].Name);
        setPhoneNo(response.data.message[0].mobileNo);
        setAdharCardNo(response.data.message[0].adharNo);
      } else {

      }

      // setTimeout(() => {
      //     // navigate("/viewMember");
      //     setOpen(false);
      //     setRefreshData((oldValue) => !oldValue);
      // }, 6000); // Matches autoHideDuration
    } catch (err) {
      if (!err?.response) {
        console.log("No server response");
      } else {
        console.log(err?.response.data);
        setAge('');
        setMembername('');
        setMembername('');
        setPhoneNo('');
        setAdharCardNo('');
        setSeverity("error");
        setMessage('Data Not Found');
        setAlertOpen(true);
      }
    }
  };
  const fetchPaymentData = async () => {
    try {
      var data;
      if (searchType == "AdharCardNo") {
        data = { searchType, value: adharCardNo, retiredPerson: retirementPerson };
      } else if (searchType == "MemberId") {
        data = { searchType, value: memberid, retiredPerson: retirementPerson };
      } else {
        data = { searchType, value: phoneNo, retiredPerson: retirementPerson };
      }

      const response = await axios.post("./payment/getAdvanceSearch", data);

      if (response.data.success == 1) {
        console.log(response.data);
        setSeverity("success");
        setMessage('Payment Already Added');
        setAlertOpen(true);
      } else {

      }

      // setTimeout(() => {
      //     // navigate("/viewMember");
      //     setOpen(false);
      //     setRefreshData((oldValue) => !oldValue);
      // }, 6000); // Matches autoHideDuration
    } catch (err) {
      if (!err?.response) {
        console.log(err);
      } else {
        console.log(err?.response.data);
        setSeverity("error");
        setMessage('Payment Not Added');
        setAlertOpen(true);
      }
    }
  };

  const fetchRetiredData = async (e) => {
    const retiredTypeData = e.target.value;
    console.log("user retired Type" + retiredTypeData);
    setUserDefault(retiredTypeData);
    setRetirementList([]);
    if (retiredTypeData == 1) {
      loadRetirementCount();
    } else {

    }
  }

  const fetchRetiredDataList = async (e) => {
    setRetirementList([]);
    if (fromDate === "" || toDate === "") {
      alert("Both From Date and To Date cannot be empty!");
      return false;
    }

    if (new Date(toDate) <= new Date(fromDate)) {
      alert("To Date must be greater than From Date!");
      return false;
    } else {
      try {
        const response = await axios.post("./employeeInformation/insertRetirementData", { type: "Print", fromDate, toDate });
        // setDataList(response.data.data || []);
        // setRetiredList
        if (response.data.status === 401) {
          setRetirementList([]); // Keep as empty array in case of unauthorized response
        } else {
          // const responseData = response.data.data;
          // setRetiredList(response.data.message);

          console.log("dataList", response.data.message);

          const retiredDataSet = [];


          const values = response.data.message.map((employee, index) => {
            const { memberID, Name, fathersName, adharNo, dob, joinDate, mobileNo, department, retirementDate, year_month, day } = employee;

            var sequence = parseInt(index) + 1;
            var retiredId = "RET" + year_month + day + "_" + sequence;

            // Return the array of values for each employee
            retiredDataSet.push({ retiredId, Name, year: "2024", memberID });
          });
          // datalist after Filter (2) ['RET2024_DEC22_1', 'RET2024_DEC31_2']
          // console.log("datalist after Filter", retiredDataSet);
          setRetirementList(retiredDataSet);

        }

        // setTimeout(() => {
        //     // navigate("/viewMember");
        //     setOpen(false);
        //     setRefreshData((oldValue) => !oldValue);
        // }, 6000); // Matches autoHideDuration
      } catch (err) {
        if (!err?.response) {
          console.log(err);
        } else {
          // setSeverity("error");
          // setMessage(err?.response.data.message);
          // setAlertopen(true);
          // setRefreshData((oldValue) => !oldValue);
          // console.log(err?.response.data.message);
        }
      }
    }
  }








  return (
    <>
      <div style={{ marginTop: '100px', padding: '0px' }}>
        <Typography variant="h5" sx={{ color: 'grey' }}>
          Add Payment
        </Typography>
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 3,
            border: '1px solid rgb(229 231 235 / 99%);',
            borderRadius: '8px',
          }}
        >
          <Stack direction="row" spacing={2} sx={{ alignItems: 'center' }}>
            <FormControl fullWidth>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={userDefault}
                onChange={fetchRetiredData}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 200,
                    },
                  },
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderColor: 'lightgray',
                    },
                    '&:hover fieldset': {
                      borderColor: 'lightgray',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: 'lightgray',
                    },
                  },
                }}
              >
                <MenuItem value="">
                  <em>Select Retirement List</em>
                </MenuItem>

                {/* Add Retirement and Donation options */}
                <MenuItem value="1">Normal Retirement</MenuItem>
                <MenuItem value="2">Custom Retirement</MenuItem>

              </Select>
            </FormControl>
            {/* <TextField
              label="Retirement Person"
              fullWidth
              value={retirementPerson}
              onChange={(e) => setRetirementPerson(e.target.value)}
              sx={textfieldStyles}
            /> */}
            <FormControl fullWidth>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={retirementPerson}
                onChange={(e) => setRetirementPerson(e.target.value)}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 200,
                    },
                  },
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderColor: 'lightgray',
                    },
                    '&:hover fieldset': {
                      borderColor: 'lightgray',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: 'lightgray',
                    },
                  },
                }}
              >
                <MenuItem value="">
                  <em>Please Select Retirement</em>
                </MenuItem>
                {retirementList.map((retirement, index) => (
                  <MenuItem key={index} value={retirement.retiredId}>
                    {retirement.retiredId}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl fullWidth>
              <Paper
                component="form"
                sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', }}
              >
                {/* <IconButton sx={{ p: '10px' }} aria-label="menu">
                <MenuIcon />
              </IconButton> */}
                <InputBase
                  sx={{ ml: 1, flex: 1 }}
                  placeholder="Search Member ID"
                  inputProps={{ 'aria-label': 'search member id' }}
                  value={searchKey}
                  onChange={(e) => setSearchKey(e.target.value)}
                />
                <IconButton type="button" sx={{ p: '10px' }} aria-label="search">
                  <SearchIcon onClick={fetchMemberData} />
                </IconButton>
                <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                {/* <IconButton color="primary" sx={{ p: '10px' }} aria-label="directions">
                <DirectionsIcon />
              </IconButton> */}
              </Paper>
            </FormControl>

            <FormControl fullWidth>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={searchType}
                onChange={(e) => setSearchType(e.target.value)}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 200,
                    },
                  },
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderColor: 'lightgray',
                    },
                    '&:hover fieldset': {
                      borderColor: 'lightgray',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: 'lightgray',
                    },
                  },
                }}
              >
                <MenuItem value="none">
                  <em>Search By</em>
                </MenuItem>

                {/* Add Retirement and Donation options */}
                <MenuItem value="AdharCardNo">Adhar Card No</MenuItem>
                <MenuItem value="MemberId">Member</MenuItem>
                <MenuItem value="MobileNo">Mobile No</MenuItem>
              </Select>
            </FormControl>

          </Stack>
          <Stack direction="row" spacing={2} sx={{ alignItems: 'center', mt: 2 }}>
            <TextField
              label="Member ID"
              fullWidth
              value={memberid}
              onChange={(e) => setMemberid(e.target.value)}
              sx={textfieldStyles}
            />
            <TextField
              label="Member Name"
              fullWidth
              value={membername}
              onChange={(e) => setMembername(e.target.value)}
              sx={textfieldStyles}
            />
            <TextField
              label="Age"
              fullWidth
              type="text"
              value={age}
              onChange={(e) => setAge(e.target.value)}
              sx={textfieldStyles}
            />
            <TextField
              label="Adhar Card No"
              fullWidth
              type="text"
              value={adharCardNo}
              onChange={(e) => setAdharCardNo(e.target.value)}
              sx={textfieldStyles}
            />
            <TextField
              label="Mobile No"
              fullWidth
              type="text"
              value={phoneNo}
              onChange={(e) => setPhoneNo(e.target.value)}
              sx={textfieldStyles}
            />

          </Stack>
          <Stack direction="row" spacing={2} sx={{ alignItems: 'center', mt: 2 }}>
            <TextField
              label="Amount"
              fullWidth
              type="number"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              sx={textfieldStyles}
            />

            <TextField
              label="Remarks"
              fullWidth
              value={remarks}
              onChange={(e) => setRemarks(e.target.value)}
              sx={textfieldStyles}
            />
            <FormControl fullWidth>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={type}
                onChange={(e) => setType(e.target.value)}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 200,
                    },
                  },
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderColor: 'lightgray',
                    },
                    '&:hover fieldset': {
                      borderColor: 'lightgray',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: 'lightgray',
                    },
                  },
                }}
              >
                <MenuItem value="">
                  <em>Please Select Department</em>
                </MenuItem>

                {/* Add Retirement and Donation options */}
                <MenuItem value="Retirement">Retirement</MenuItem>
                <MenuItem value="Donation">Donation</MenuItem>

              </Select>
            </FormControl>
            <FormControl fullWidth>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={paymentType}
                onChange={(e) => setpaymentType(e.target.value)}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 200,
                    },
                  },
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderColor: 'lightgray',
                    },
                    '&:hover fieldset': {
                      borderColor: 'lightgray',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: 'lightgray',
                    },
                  },
                }}
              >
                <MenuItem value="">
                  <em>Please Select Department</em>
                </MenuItem>

                {/* Add Retirement and Donation options */}
                <MenuItem value="Cash">Cash</MenuItem>
                <MenuItem value="Online">Online</MenuItem>

              </Select>
            </FormControl>


          </Stack>
          {
            userDefault == 2 ?
              <Grid container spacing={2} sx={{ marginTop: '5px' }}>
                <Grid item xs={2} >
                  <FormControl fullWidth>
                    <Typography variant="subtitle2">From Date</Typography>
                    <TextField
                      // label="From Date"
                      variant="outlined"
                      type="date" // This makes the field accept only dates
                      id="joinDate"
                      value={fromDate}
                      onChange={(e) => setFromDate(e.target.value)}
                      sx={{ marginBottom: 2 }}  // Add some spacing below the input
                      fullWidth  // Make it full width
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={2} >
                  <FormControl fullWidth>
                    <Typography variant="subtitle2">To Date</Typography>
                    <TextField
                      // label="From Date"
                      variant="outlined"
                      type="date" // This makes the field accept only dates
                      id="joinDate"
                      value={toDate}
                      onChange={(e) => setToDate(e.target.value)}
                      sx={{ marginBottom: 2 }}  // Add some spacing below the input
                      fullWidth  // Make it full width
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={8} />
              </Grid> : ""
          }


          <div>
            <Button
              size="large"
              variant="contained"
              sx={{
                backgroundColor: '#0d2365',
                mt: 3,
                '&:hover': {
                  backgroundColor: '#0d2365',
                },
                borderRadius: '10px',
                margin: '10px'
              }}
              onClick={handleSave}
            >
              {action == "update" ? "Update Payment" : "Add Payment"}
            </Button>
            {/* 
            <Button
              size="large"
              variant="contained"
              sx={{
                backgroundColor: '#0d2365',
                mt: 3,
                '&:hover': {
                  backgroundColor: '#0d2365',
                },
                borderRadius: '10px',
                margin: '10px'
              }}
              onClick={fetchMemberData}
            >
              Search
            </Button> */}


            <Button
              size="large"
              variant="contained"
              sx={{
                backgroundColor: '#0d2365',
                mt: 3,
                '&:hover': {
                  backgroundColor: '#0d2365',
                },
                borderRadius: '10px',
                margin: '10px'
              }}
              onClick={fetchPaymentData}
            >
              Advance Search
            </Button>
            {
              userDefault == 2 ?
                <Button
                  size="large"
                  variant="contained"
                  sx={{
                    backgroundColor: '#0d2365',
                    mt: 3,
                    '&:hover': {
                      backgroundColor: '#0d2365',
                    },
                    borderRadius: '10px',
                    margin: '10px'
                  }}
                  onClick={fetchRetiredDataList}
                >
                  Fetch Retired Data
                </Button> : ""
            }

          </div>
          <Snackbar open={alertOpen} autoHideDuration={6000} onClose={handleClose}>
            <Alert
              onClose={handleClose}
              severity={severity}
              variant="filled"
              sx={{ width: '100%' }}
            >
              {message}
            </Alert>
          </Snackbar>
        </Box>
      </div>
    </>
  );
}

const textfieldStyles = {
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: 'lightgray',
    },
    '&:hover fieldset': {
      borderColor: 'lightgray',
    },
    '&.Mui-focused fieldset': {
      borderColor: 'lightgray',
    },
  },
};

export default AddPayment;
